export default "/images/vendor/flag-icons/flags/4x3/np.svg?cdc41ea23d08179ac7c1a066bcef7ab3";